<template>
    <div class="agent-settlement-statistics">
        <b-card class="mb-4">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                        <i class="fas fa-chart-pie mr-2"></i>
                        {{ isAgent ? 'Моя статистика выплат' : 'Общая статистика выплат агентам' }}
                    </h5>
                    <b-button 
                        size="sm" 
                        variant="outline-primary" 
                        @click="loadStatistics"
                        :disabled="loading"
                    >
                        <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                        Обновить
                    </b-button>
                </div>
            </template>

            <div v-if="loading" class="text-center py-4">
                <b-spinner variant="primary"></b-spinner>
                <div class="mt-2">Загрузка статистики...</div>
            </div>

            <div v-else-if="error" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                {{ error }}
            </div>

            <div v-else class="statistics-grid">
                <div class="stat-card">
                    <div class="stat-icon approved">
                        <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">Начислено и одобрено</div>
                        <div class="stat-value text-success">
                            {{ (statistics.approved_and_credited && statistics.approved_and_credited.formatted) || '0,00 ₽' }}
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-icon pending">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">Начислено и ожидает одобрения</div>
                        <div class="stat-value">
                            {{ (statistics.pending_and_credited && statistics.pending_and_credited.formatted) || '0,00 ₽' }}
                        </div>
                    </div>
                </div>

                <!-- <div class="stat-card">
                    <div class="stat-icon rejected">
                        <i class="fas fa-times-circle"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">Начислено и отклонено</div>
                        <div class="stat-value text-danger">
                            {{ (statistics.rejected_and_credited && statistics.rejected_and_credited.formatted) || '0,00 ₽' }}
                        </div>
                    </div>
                </div> -->

                <div class="stat-card">
                    <div class="stat-icon withdrawn">
                        <i class="fas fa-money-bill-wave"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">Выведено</div>
                        <div class="stat-value">
                            {{ (statistics.withdrawn && statistics.withdrawn.formatted) || '0,00 ₽' }}
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-icon pending-withdrawal">
                        <i class="fas fa-hourglass-half"></i>
                    </div>
                    <div class="stat-content">
                        <div class="stat-label">Ожидается к выводу</div>
                        <div class="stat-value">
                            {{ (statistics.pending_withdrawal && statistics.pending_withdrawal.formatted) || '0,00 ₽' }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 text-muted small">
                <i class="fas fa-info-circle mr-1"></i>
                Статистика за все время
            </div>
        </b-card>
    </div>
</template>

<script>
import { API_AGENT_SETTLEMENTS } from "@/constants";

export default {
    name: 'AgentSettlementStatistics',
    data() {
        return {
            loading: false,
            error: null,
            statistics: {},
            isAgent: false
        }
    },
    mounted() {
        this.loadStatistics();
    },
    methods: {
        loadStatistics() {
            this.loading = true;
            this.error = null;

            api.call('get', `${API_AGENT_SETTLEMENTS}/comprehensive-statistics`)
                .then(response => {
                    if (response.data.success) {
                        this.statistics = response.data.data;
                        this.isAgent = response.data.is_agent;
                    } else {
                        this.error = response.data.message || 'Ошибка загрузки статистики';
                    }
                })
                .catch(error => {
                    console.error('Error loading statistics:', error);
                    this.error = 'Не удалось загрузить статистику. Попробуйте позже.';
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped>
.agent-settlement-statistics {
    margin-bottom: 2rem;
}

.statistics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
}

.stat-card {
    display: flex;
    align-items: center;
    padding: 1.5rem;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #dee2e6;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    font-size: 1.5rem;
}

.stat-icon.approved {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
    border-left-color: #28a745;
}

.stat-icon.pending {
    background: rgba(255, 193, 7, 0.1);
    color: #ffc107;
    border-left-color: #ffc107;
}

.stat-icon.rejected {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
    border-left-color: #dc3545;
}

.stat-icon.withdrawn {
    background: rgba(23, 162, 184, 0.1);
    color: #17a2b8;
    border-left-color: #17a2b8;
}

.stat-icon.pending-withdrawal {
    background: rgba(0, 123, 255, 0.1);
    color: #007bff;
    border-left-color: #007bff;
}

.stat-content {
    flex: 1;
}

.stat-label {
    font-size: 0.875rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
    font-weight: 500;
}

.stat-value {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.2;
}

@media (max-width: 768px) {
    .statistics-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .stat-card {
        padding: 1rem;
    }
    
    .stat-icon {
        width: 40px;
        height: 40px;
        font-size: 1.25rem;
    }
    
    .stat-value {
        font-size: 1.1rem;
    }
}
</style>
